import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../../../../i18n";
import type { ClassificationQuantity } from "../../../../../api/useClassificationQuantities";

export const useUnitInput = (selectedQuantities: ClassificationQuantity[]) => {
  const hasSameValue = React.useMemo(
    () =>
      selectedQuantities.filter(quantity => quantity.unit !== selectedQuantities[0]?.unit)
        .length === 0,
    [selectedQuantities],
  );

  const defaultValue = React.useMemo(() => {
    if (hasSameValue) return selectedQuantities[0]?.unit ?? "";
    return "";
  }, [selectedQuantities, hasSameValue]);

  const input = useInput(defaultValue);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue) return t("administration.modal.multiple_value");
    if (defaultValue === "") return t("form.no_value");
    return defaultValue;
  }, [hasSameValue, defaultValue]);

  return {
    placeholder,
    ...input,
  };
};
